/* lua.js generated code 0.3.0 */

TileItem = xClass("TileItem")
function tileSort(a, b) {
    if (a.layer < b.layer) {
        return true
    }
    return false
}
TileItem.prototype.ctor = function (data) {
    var self = this
    var defs = table()
    for (var i = 1, v = data[1]; !$null(v); i++, v = data[i]) {
        var def = GameItemDefManager.getDef(v)
        table.insert(defs, def)
    }
    // table.sort(defs, tileSort)
    self.defs = defs
}
//返回配置的初始颜色
TileItem.prototype.getColor = function () {
    var self = this
    for (var i = 1, v = self.defs[1]; v; i++, v = self.defs[i]) {
        if (v.color && v.color > 0 && v.itemType) {
            return v.color
        }
    }
    return 0
}
TileItem.prototype.initGameItem = function (mainLogic, r, c) {
    var self = this
    var item = mainLogic.gameItemMap[r][c]
    var board = mainLogic.boardmap[r][c]
    for (var i = 1, v = self.defs[1]; v; i++, v = self.defs[i]) {
        if (item) {
            item.x = c
            item.y = r
            v.initGameItem(item, mainLogic)
        }
        if (board) {
            board.x = c
            board.y = r
            v.initBoardItem(board, mainLogic)
        }
    }
    if ($len(self.defs) === 0) {
        if (item) {
            item.x = c
            item.y = r
        }
        if (board) {
            board.x = c
            board.y = r
        }
    }
}
TileItem.prototype.initGameItemInTurnTile = function (mainLogic, item, board, r, c) {
    let self = this
    for (let i = 1, v = self.defs[1]; v; i++, v = self.defs[i]) {
        if (item) {
            item.x = c
            item.y = r
            v.initGameItem(item, mainLogic)
            v.addedToGameBoard(item, mainLogic)
        } else {
            cc.log("[TurnTileNode] ERROR: initGameItemInTurnTile item nil")
        }
        if (board) {
            board.x = c
            board.y = r
            v.initBoardItem(board, mainLogic)
        } else {
            cc.log("[TurnTileNode] ERROR: initGameItemInTurnTile board nil")
        }
    }
    if ($len(self.defs) === 0) {
        if (item) {
            item.x = c
            item.y = r
        }
        if (board) {
            board.x = c
            board.y = r
        }
    }
}
TileItem.prototype.initDropDig = function (mainLogic, item, board, r, c) {
    var self = this
    for (var i = 1, v = self.defs[1]; v; i++, v = self.defs[i]) {
        if (item) {
            item.x = c
            item.y = r
            v.initGameItem(item, mainLogic)
            v.addedToGameBoard(item, mainLogic)
        }
        if (board) {
            board.x = c
            board.y = r
            v.initBoardItem(board, mainLogic)
        }
    }
}
